import React from 'react';
import { typeMeta, statusLabel, priorityLabel, refLabel } from '../constants/supportCases';
import { formatCaseDate } from '../utils/formatCaseDate';
import { CaseTypeIcon } from './icons';
import Avatar from './Avatar';
import './CaseHero.css';

function Field({ label, children }) {
  return (
    <div className="case-hero-field">
      <span className="case-hero-label">{label}</span>
      <span className="case-hero-value">{children}</span>
    </div>
  );
}

/**
 * Salesforce-style highlights header for a case: type icon + eyebrow + big title,
 * then a labeled field strip. showTenant adds Tenant/agent context (Support Console).
 */
function CaseHero({ supportCase, showTenant = false, showAssignee = showTenant }) {
  const meta = typeMeta(supportCase.type);
  const reporter = supportCase.created_by_name || supportCase.created_by_username || '—';
  const assignee = supportCase.assigned_agent_name || supportCase.assigned_agent_username || null;

  return (
    <div className="case-hero">
      <div className={`case-hero-icon type-${supportCase.type}`} aria-hidden>
        <CaseTypeIcon type={supportCase.type} size={26} />
      </div>
      <div className="case-hero-body">
        <div className="case-hero-eyebrow">
          Support case{showTenant && supportCase.tenant_code ? ` · ${supportCase.tenant_code}` : ''}
        </div>
        <h1 className="case-hero-title">
          <span className="case-hero-num">{refLabel(supportCase.ref)}</span> {supportCase.subject}
        </h1>
        <div className="case-hero-fields">
          {showTenant && (
            <Field label="Tenant">{supportCase.tenant_name || supportCase.tenant_code || '—'}</Field>
          )}
          <Field label="Reported by">{reporter}</Field>
          <Field label="Type">{meta.label}</Field>
          <Field label="Status">{statusLabel(supportCase.status)}</Field>
          <Field label="Priority">
            {supportCase.priority
              ? <span className={`case-priority priority-${supportCase.priority}`}>{priorityLabel(supportCase.priority)}</span>
              : '—'}
          </Field>
          <Field label="Opened">{formatCaseDate(supportCase.created_at)}</Field>
          {supportCase.closed_at && <Field label="Closed">{formatCaseDate(supportCase.closed_at)}</Field>}
          {supportCase.fixed_in_version && <Field label="Fixed in">{supportCase.fixed_in_version}</Field>}
          {showAssignee && (
            <Field label="Assigned to">
              {assignee ? (
                <span className="case-hero-person"><Avatar userId={supportCase.assigned_agent_user_id} name={assignee} size={22} /> {assignee}</span>
              ) : 'Unassigned'}
            </Field>
          )}
        </div>
      </div>
    </div>
  );
}

export default CaseHero;
